import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/site";

/**
 * Brand lockup. Uses the AI-generated logo pack from /downloads/logo/.
 * - variant="dark"  → header on light background (horizontal navy+gold on white)
 * - variant="light" → footer on dark navy (stacked gold+cream on navy)
 */
export default function Logo({ variant = "dark", className = "" }) {
  const light = variant === "light";
  const src = light
    ? "/downloads/logo/logo-primary-dark.png"
    : "/downloads/logo/logo-horizontal.png";

  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center group ${className}`}
      aria-label={BRAND.fullName}
    >
      <img
        src={src}
        alt={BRAND.fullName}
        className={
          light
            ? "h-16 md:h-20 w-auto object-contain"
            : "h-12 md:h-14 w-auto object-contain"
        }
      />
    </Link>
  );
}
